<!--
 * @FileDescription: 单据审核（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-01（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
          <a-table :columns="columns"
                   :dataSource="dataSource"
                   :pagination="false"
                   bordered
                   :scroll="{y:'calc(100vh - 300px)' }"
                   class="price-table"
          >
              <template slot="data2" slot-scope="text, record">
                  <span :class="record.state == 1 ? '' : 'audit-span'">{{text}}</span>
              </template>
              <template slot="data3" slot-scope="text, record">
                  <div style="display: flex" v-has="'system_audit_operation'">
                      <a-switch v-model="record.isCheck" @change="e=>onChangeSwitch(e,record)" />
                      <span class="table-name" @click="onClickName(record)" v-if="record.state == 1">修改审核人</span>
                  </div>
              </template>
              <template slot="data4" slot-scope="text, record">

              </template>
          </a-table>
      </div>
      <auditMdoel ref="auditMdoel" @auditpageList="auditpageList"></auditMdoel>
  </div>
</template>
<script>
    //修改
import {voucherList,voucherUpdate} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import auditMdoel from './model/auditModel'
export default {
    mixins:[mixins],
    data(){
        return{
            loading:true,
            columns:[
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 80,
                    align: "center",
                    customRender: function (t, r, index) {
                        return parseInt(index) + 1;
                    }
                },
                {
                    title: '数据类型',
                    key: 'voucherType',
                    dataIndex: 'voucherType',
                    customRender: function (t, r, index) {
                        if(t==1){
                            return '采购入库'
                        }else if(t==2){
                            return '销售退货入库'
                        }else if(t==3){
                            return '其他入库'
                        }else if(t==4){
                            return '库存报溢 '
                        }else if(t==5){
                            return '销售出库'
                        }else if(t==6){
                            return '采购退货出库'
                        }else if(t==7){
                            return '其他出库'
                        }else if(t==8){
                            return '库存报损 '
                        }else if(t==9){
                            return '库存调拨'
                        }else if(t==10){
                            return '库存组装拆卸单'
                        }else if(t==11){
                            return '付款单'
                        }else if(t==12){
                            return '收款单'
                        }else if(t==13){
                            return '其他支出单'
                        }else{
                            return '其他收入单'
                        }
                    }
                },
                {
                    title: '审核人',
                    key: 'auditorName',
                    dataIndex: 'auditorName',
                    scopedSlots: { customRender: 'data2' },
                },
                {
                    title: '是否启用',
                    key: 'state',
                    dataIndex: 'state',
                    scopedSlots: { customRender: 'data3' },
                },
            ],
            dataSource:[],
        }
    },
    watch: {
    },
    mounted () {
        this.getList()
    },
    created () {

    },
    components: {
        auditMdoel,

    },
    methods: {
        getList(){
            this.$store.state.isLoding = true
            let data = new FormData()
            data.append('companyStoreId',this.$store.state.shopId)
            voucherList(data,{ 'Content-Type':'application/json'}).then((res)=>{
                if(res.success){
                    this.$store.state.isLoding = false
                    res.result.forEach((item)=>{
                        item.isCheck = item.state == 1
                    })
                    this.dataSource = res.result
                }
            })
        },
        /**
        * @description: 此为方法注释（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */
        onClickName(record){
          console.log(record)
            this.$refs.auditMdoel.onOpen(record,record.isCheck)
        },
        auditpageList(){
            this.getList()
        },
        onChangeSwitch(value,record){
            if(this.isEmpty(record.auditorId)){
                // record.state = value ? '1' : '0'
                this.$refs.auditMdoel.onOpen(record,value)
                record.isCheck = !value
                return
            }
            voucherUpdate({
                auditorId:record.auditorId,
                companyStoreId:this.$store.state.shopId,
                companyId:this.$store.state.companyId,
                id:record.id,
                voucherType:record.voucherType,
                state:value ? 1 : 0
            },{}).then((res)=>{
                if(res.success){
                    record.isCheck = value
                    this.$message.success(res.logMessage)
                    this.getList()
                }else{
                    record.isCheck = !value
                    this.$message.warn(res.logMessage)
                }
            })
        }
    },

}
</script>
<style lang="scss">
    .price-table{
        margin-top: 32px;
        .ant-pagination{
            display: none;
        }
    }
</style>
<style scoped lang="scss">
    .page-container-height{
        background-color: #fff;
        .price-title{
            color: #333333;
            font-size: 22px;
            font-weight: 700;
            padding: 72px 0 43px 69px;
        }
        .table-name,.table-name1{
            cursor: pointer;
            color: #387BFC;
            font-size: 14px;
            margin-left: 20px;
        }
        .table-name1{
            margin-left: 26px;
        }
        .audit-span{
            color: #AAAAAA;
        }
        .audit-state{
            display: flex;
            align-items: center;
            .audit-state-cir{
                width: 4px;
                height: 4px;
                background-color: #35AD00;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        .audit-state1{
            color: #FF0000;
            .audit-state-cir{
                background-color: #FF0000;
            }
        }
    }
</style>
